import type { TGlobalState } from '@/types/state-types'

export default {
  isUserLoggedIn(state: TGlobalState) {
    return Boolean(state.userId && state.accessToken)
  },
  isLoading(state: TGlobalState) {
    return Boolean(state.loader)
  },
  errorCaught(state: TGlobalState) {
    return Boolean(state.errors?.length)
  },
  totalNotifications(state: TGlobalState) {
    return state.toastNotifications?.length
  },
  refreshAttemptsExceeded(state: TGlobalState) {
    return state.refreshAttempts >= 3
  },
  hasSignalROfficerWorker(state: TGlobalState) {
    return !!state.officerWorker
  }
}
